import { componentsConfig as sharedComponents } from 'srs.sharedcomponents/lib/esm/components/config'
import EsstComponent from '../../srs.esst.component'
import MinimumStandardComponent from '../../srs.minimumStandard.component'
import WelcomeBuilder from 'srs.sharedcomponents/lib/esm/components/organisms/Welcome/BuilderContent/WelcomeBuilder'
const componentsConfig = {
  ...sharedComponents,
  EsstComponent: EsstComponent,
  MinimumStandardComponent: MinimumStandardComponent,
  WelcomeContent: WelcomeBuilder,
}

export { componentsConfig }
